import React, { FunctionComponent } from 'react';
import { Image, Button } from '@mantine/core';
import { useLocalStorage } from '@mantine/hooks';
import { IconArrowRight, IconX } from '@tabler/icons-react';

import useMobile from 'src/shared/hooks/use-mobile';
import twModal from 'src/assets/images/tw/modal-announcement.png';

import styles from '../styles/tw-announcement-styles.module.scss';
import { AnnouncementStorageKeys, TW_ANNOUNCEMENT_URL } from '../constants';

export const TwModalComponent: FunctionComponent = () => {
    const mobile = useMobile();
    const [modalSeen, setModalSeen] = useLocalStorage({
        key: AnnouncementStorageKeys.modal,
        defaultValue: false,
    });

    if (mobile || modalSeen) return null;

    return (
        <div className={styles.modal} onClick={() => setModalSeen(true)}>
            <div className={styles.modalContent}>
                <IconX
                    className={styles.modalCloseIcon}
                    size={'2.4vw'}
                    stroke={1.5}
                    onClick={() => setModalSeen(true)}
                />
                <Image
                    className={styles.modalImage}
                    onClick={(e: React.MouseEvent<HTMLImageElement>) => e.stopPropagation()}
                    src={twModal}
                />
                <Button
                    variant="unstyled"
                    rightSection={<IconArrowRight />}
                    styles={{ section: { margin: 0 }, label: { marginLeft: -8, marginRight: 8 } }}
                    className={styles.modalButton}
                    size="xl"
                    radius="lg"
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                        setModalSeen(true);
                        e.stopPropagation();
                        window.open(TW_ANNOUNCEMENT_URL, '_blank');
                    }}
                >
                    Learn more
                </Button>
            </div>
        </div>
    );
};
